import { createFileRoute } from '@tanstack/react-router'
import { FlowPreviewPage } from '#pages/client/FlowPreviewPage'

export const Route = createFileRoute('/_app/flow/$flowId')({
  component: FlowPreviewPage,
})
